import { parse } from 'query-string';

/* eslint-disable import/prefer-default-export */
export const getQueryParams = (state) => {
  const data = state.router;
  if (data) {
    return parse(data.location?.search);
  }
  return null;
};
